module.exports = __webpack_public_path__ + "static/media/btnpalante.72047387.png";